import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";
import { isEmpty } from "lodash";

import { Side } from "../SideMenu/side";

import { getTotalPrice } from "../../store/sagas/selectors";

interface ConfiguratorTotalPriceContainerProps {
    side: Side;
}

const ConfiguratorTotalPriceContainer = styled.div<ConfiguratorTotalPriceContainerProps>`
    @media (min-width: 200px) and (max-width: 720px) {
        left: auto;
        right: 0;
        margin: 10px;
    }
    @media (min-width: 200px) and (orientation: landscape) {
        left: 0;
        right: auto;
        margin: 30px;
    }
    @media (min-width: 720px) and (orientation: portrait) {
        left: auto;
        right: 0;
        margin: 10px;
    }
    @media (min-width: 1024px) {
        left: ${({ side }) => (side === Side.Right ? 0 : "auto")};
        right: ${({ side }) => (side === Side.Right ? "auto" : 0)};
        margin: 30px;
    }
    top: 0;
    position: absolute;
    max-width: 50%;
    z-index: 2;
`;

const ConfiguratorTotalPriceSeparatorBox = styled.span`
    ${({ theme }) => theme.bp.xs`
        padding: .8vw;
    `};
    ${({ theme }) => theme.bp.sm`
        padding: .4vw;
    `};
`;

const ConfiguratorTotalPriceValueBox = styled.div`
    font-size: 1.4em;
    padding: 1px 4px 2px;
    margin: 2px;
    background-color: #636363;
    display: inline-block;
    color: #fff;
    line-height: 1;
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1.9em;
                `}
`;

const ConfiguratorTotalPriceCurrency = styled.div`
    font-size: 1.4em;
    padding: 1px 4px 2px;
    margin: 2px;
    display: inline-block;
    color: #636363;
    line-height: 1;
`;

export const ConfiguratorTotalPrice = ({ side }: { side: Side }) => {
    const totalPrice = useSelector(getTotalPrice);

    if (!totalPrice) return null;

    const values = Math.round(totalPrice.priceValue).toLocaleString("sv-SE").split("");
    if (!values) return null;

    const digits = values.map((x: string, index: number) => {
        return isEmpty(x.trim()) ? (
            <ConfiguratorTotalPriceSeparatorBox key={`${x}${index + 1}`} />
        ) : (
            // The linter complains if the index is used
            <ConfiguratorTotalPriceValueBox key={`${x}${index + 1}`}>{x}</ConfiguratorTotalPriceValueBox>
        );
    });
    return (
        <ConfiguratorTotalPriceContainer side={side}>
            {totalPrice.currencyIsPrefixed ? (
                <>
                    <ConfiguratorTotalPriceCurrency>{totalPrice.currencySymbol} </ConfiguratorTotalPriceCurrency>
                    {digits}
                </>
            ) : (
                <>
                    {digits}
                    <ConfiguratorTotalPriceCurrency>{totalPrice.currencySymbol} </ConfiguratorTotalPriceCurrency>
                </>
            )}
        </ConfiguratorTotalPriceContainer>
    );
};
